// extracted by mini-css-extract-plugin
export var playerContainer = "Player-module--playerContainer--3-no3";
export var removePlayerButton = "Player-module--removePlayerButton--1itx8";
export var playerNameInput = "Player-module--playerNameInput--1Y7OW";